import NetworkApi from './networkApi';
import paths from './path';

export const getGroupByOptions = async ({ metric, subMetric, chartType }) => {
  const options = {
    withPermission: true,
    Authorization: `${localStorage.getItem('token')}`,
  };
  const { groupByOptions } = await NetworkApi.get(
    paths.groupBys({ metric, subMetric, chartType }),
    options
  );

  return groupByOptions;
};

export const getChartTypesOptions = async () => {
  const options = {
    withPermission: true,
    Authorization: `${localStorage.getItem('token')}`,
  };

  const response = await NetworkApi.get(paths.chartTypes(), options);
  const chartTypesOptions = response.chartFilters;
  return chartTypesOptions;
};

export const getDateRangesOptions = async () => {
  const options = {
    withPermission: true,
    Authorization: `${localStorage.getItem('token')}`,
  };

  const { dateRangeOptions } = await NetworkApi.get(paths.DateRanges(), options);

  return dateRangeOptions;
};

export const getMetricOptions = async ({ chartType }) => {
  const options = {
    withPermission: true,
    Authorization: `${localStorage.getItem('token')}`,
  };

  const { metricOptions } = await NetworkApi.get(paths.metricOptions({ chartType }), options);

  return metricOptions;
};

export const getAxisOptions = async ({ metric, subMetric, chartType }) => {
  const options = {
    withPermission: true,
    Authorization: `${localStorage.getItem('token')}`,
  };
  const { xAxisOptions } = await NetworkApi.get(
    paths.getAxisOptions({ metric, subMetric, chartType }),
    options
  );

  return xAxisOptions;
};

export const getAttributeLabels = async () => {
  const options = {
    withPermission: true,
    Authorization: `${localStorage.getItem('token')}`,
  };

  const { AttributeLabels } = await NetworkApi.get(paths.getAttributeLabels(), options);

  return AttributeLabels;
};

export const getChartConfig = async () => {
  const options = {
    withPermission: true,
    Authorization: `${localStorage.getItem('token')}`,
  };

  const data = await NetworkApi.get(paths.getChartConfig(), options);
  return data;
};

export const getGroupByMapping = async () => {
  const options = {
    withPermission: true,
    Authorization: `${localStorage.getItem('token')}`,
  };

  const data = await NetworkApi.get(paths.groupByMapping, options);
  return data;
};

export const getDrilldownConfig = async () => {
  const options = {
    withPermission: true,
    Authorization: `${localStorage.getItem('token')}`,
  };

  const data = await NetworkApi.get(paths.getDrilldownConfig(), options);
  return data;
};

export const getGridLayoutConstants = async () => {
  const options = {
    withPermission: true,
    Authorization: `${localStorage.getItem('token')}`,
  };
  const { gridLayoutConstants } = await NetworkApi.get(paths.gridLayoutConstants(), options);
  return gridLayoutConstants;
};

export const getGridLayoutValidation = async () => {
  const options = {
    withPermission: true,
    Authorization: `${localStorage.getItem('token')}`,
  };
  const { gridLayoutValidation } = await NetworkApi.get(paths.gridLayoutValidation(), options);
  return gridLayoutValidation;
};
